module.exports = __webpack_public_path__ + "static/prado-min-29c3a96d9ebaaaa8d521ba5ffa3f9660.jpg";